import { db } from '@/store/firebase'
import firestoreUtil from '@/utils/firestore'

export default {

  printPresets: {
    getGI (idUser) {
      return db
        .doc(`users/${idUser}/printPresets/gestationInteraction`)
        .get()
        .then(payload => {
          if (!payload.exists) return

          return firestoreUtil.docToObject(payload)
        })
    },

    saveGI (idUser, presets) {
      return db.doc(`users/${idUser}/printPresets/gestationInteraction`).set(presets, {merge: true})
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/user.js